import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

export const authProvider = new PublicClientApplication(msalConfig);
